import * as THREE from 'three';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';

export default class PropertySign {
  constructor (camera, scene) {
    this.camera = camera;
    this.scene = scene;

    this.text = {
      universeNumber: '0001',
      owner: 'multiversum.eth',
      metadata: {
        type: 'Borealis (60%)',
        age: 'Child | ~1T year (40%)',
        diversity: 'High (10%)',
        singularity: 'Magnetar (5%)',
        dominantRace: 'Human (60%)'
      }
    };
    this.fontLoader = new FontLoader();
    this.fontLoader.load('fonts/Roboto_Regular.json',
      (font) => { this.font = font;},
      () => console.log('progress'),
      () => console.log('error')
    );
  }

  addPropertySign () {
    this.text.metadata = this._getLocalUniverseMetadata();

    const textOwner = `
            Universe : #${window.currentUniverse.universeNumber}
            Owner : ${this.text.owner}
        `;

    const textDescription = `
            Type : ${this.text.metadata.type}
            Age : ${this.text.metadata.age}
            Diversity : ${this.text.metadata.diversity}
            Singularity : ${this.text.metadata.singularity}
            Dominant Race : ${this.text.metadata.dominantRace}
        `;

    this.propertySignGeometryOwner = new TextGeometry(textOwner, {
      font: this.font,
      size: 1000,
      height: 1,
      curveSegments: 12,
      bevelEnabled: true,
      bevelThickness: 0,
      bevelSize: 0,
      bevelOffset: 0,
      bevelSegments: 0
    });
    this.propertySignMaterialOwner = new THREE.MeshBasicMaterial({ color: this._getTextColor(), side: THREE.BackSide });
    this.propertySignMeshOwner = new THREE.Mesh(this.propertySignGeometryOwner, this.propertySignMaterialOwner);

    this.propertySignGeometryDescription = new TextGeometry(textDescription, {
      font: this.font,
      size: 400,
      height: 1,
      curveSegments: 12,
      bevelEnabled: true,
      bevelThickness: 0,
      bevelSize: 0,
      bevelOffset: 0,
      bevelSegments: 0
    });
    this.propertySignMaterialDescription = new THREE.MeshBasicMaterial({ color: this._getTextColor(), side: THREE.BackSide });
    this.propertySignMeshDescription = new THREE.Mesh(this.propertySignGeometryDescription, this.propertySignMaterialDescription);

    const z = window.isFirstUniverse ? -11000 : -31000;
    this.propertySignMeshOwner.position.set(-8000, 5000, z);
    this.propertySignMeshDescription.position.set(-5900, 500, z);
    this.scene.add(this.propertySignMeshOwner, this.propertySignMeshDescription);
  }

  dispose () {
    this.propertySignGeometryOwner.dispose();
    this.propertySignMaterialOwner.dispose();

    this.propertySignGeometryDescription.dispose();
    this.propertySignMaterialDescription.dispose();
    this.scene.remove(this.propertySignMeshOwner, this.propertySignMeshDescription);
  }

  _getLocalUniverseMetadata () {
    if (!window.currentUniverse.isReady)
      return {};

    return {
      type: window.currentUniverse.universeModifiers.type.displayName,
      age: window.currentUniverse.universeModifiers.age.displayName,
      diversity: window.currentUniverse.universeModifiers.diversity.displayName,
      singularity: window.currentUniverse.universeModifiers.singularity.displayName,
      dominantRace: window.currentUniverse.universeModifiers.dominantRace.displayName
    };
  }

  _getTextColor () {
    let color = 0xFFFFFF;

    switch (window.currentUniverse.universeModifiers.type.id) {
      case 'eternal':
        color = 0x000000;
    }

    return color;
  }

  _getOwner () {
    // todo: from the blockchain
  }

  _getUniverseMetadata () {
    // todo: from the blockchain (from universe class - from url/hash)
  }
}
